// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"69ddbd75","513":"348dc80f","703":"8fd8c83e","787":"c07b0bf7"}[chunkId] + ".chunk.js";
};